import { render, staticRenderFns } from "./FlowEditorReleaseArea.vue?vue&type=template&id=8a950410&"
import script from "./FlowEditorReleaseArea.vue?vue&type=script&lang=js&"
export * from "./FlowEditorReleaseArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports